import React from 'react'
import styled from 'styled-components'
import { bandTone } from 'utility/crm/health'
import { Avatar, Muted, Pill, Row } from './ui'

const List = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 70vh;
    overflow-y: auto;
`

const Item = styled.li`
    button {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        text-align: left;
        padding: 10px 8px;
        border: 0;
        border-left: 3px solid ${({ $active }) => ($active ? '#2563eb' : 'transparent')};
        border-bottom: 1px solid rgba(128, 128, 128, 0.2);
        background: ${({ $active }) => ($active ? 'rgba(37,99,235,.1)' : 'transparent')};
        color: inherit;
        cursor: pointer;
    }
    button:hover {
        background: rgba(37, 99, 235, 0.08);
    }
    button:focus-visible {
        outline: 2px solid #2563eb;
        outline-offset: -2px;
    }
    .grow {
        flex: 1;
        min-width: 0;
    }
    .name {
        font-weight: 600;
        overflow-wrap: anywhere;
    }
`

/**
 * Accounts with their health score. Rows open with Enter.
 * @param {{ accounts: import('utility/crm/types').CrmAccount[], activeId: number|null, onSelect: (id: number) => void }} props
 */
export const AccountList = ({ accounts, activeId, onSelect }) => (
    <List aria-label="Accounts">
        {accounts.map(account => (
            <Item key={account.AccountId} $active={account.AccountId === activeId}>
                <button type="button" aria-current={account.AccountId === activeId ? 'true' : undefined} onClick={() => onSelect(account.AccountId)}>
                    <Avatar name={account.Name} />
                    <div className="grow">
                        <div className="name">{account.Name}</div>
                        <Muted>{[account.Industry, account.AccountType].filter(Boolean).join(' · ')}</Muted>
                    </div>
                    <Row $gap={0}>
                        <Pill $tone={bandTone(account.Health?.Band)} aria-label={account.Health ? `Health ${account.Health.Score}, ${account.Health.Label}` : 'No health score'}>
                            {account.Health ? account.Health.Score : '–'}
                        </Pill>
                    </Row>
                </button>
            </Item>
        ))}
    </List>
)
